export default {
  groups: null,
  currentCategory: ''
}
